import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Projects = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">🚀 Projects</h1>
          <p className="text-muted-foreground">ongoing company initiatives (progress + deadlines)</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Projects Dashboard</CardTitle>
            <CardDescription>ongoing company initiatives (progress + deadlines)</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Projects content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Projects;